module.exports = {"360728100":"历市镇","360728101":"岿美山镇","360728102":"老城镇","360728103":"天九镇","360728104":"龙塘镇","360728105":"岭北镇","360728106":"鹅公镇","360728400":"定南县工业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360728.json
// module id = 1408
// module chunks = 0